__turbopack_context__.v({
  "arrow": "tooltip-module__ZlDb7a__arrow",
  "arrowHidden": "tooltip-module__ZlDb7a__arrowHidden",
  "tooltip": "tooltip-module__ZlDb7a__tooltip",
  "tooltipPending": "tooltip-module__ZlDb7a__tooltipPending",
  "tooltipWarning": "tooltip-module__ZlDb7a__tooltipWarning",
});
